import { createFileRoute } from '@tanstack/react-router'

import { ShipmentPage } from '#/modules/shipments/shipment-page'

export const Route = createFileRoute('/_shell/shipments/$shipmentId')({
  component: function ShipmentRoute() {
    const { shipmentId } = Route.useParams()
    return <ShipmentPage shipmentId={shipmentId} />
  },
})
